import './Header.scss';
import Logo from '../../assets/NewLogo.svg';
import LogoText from '../../assets/Pioneers.svg';
import LogoTextWhite from '../../assets/PioneersWhite.svg';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Header = ({ onFormClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isWhite, setIsWhite] = useState(false);
  const navigate = useNavigate();

  const handleScroll = () => {
    setIsMenuOpen(false);
  };

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth <= 800);
  };

  useEffect(() => {
    setIsWhite(window.location.pathname === '/');
  }, [window.location.pathname]);

  useEffect(() => {
    setIsMobile(window.innerWidth <= 800);
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  const renderHeaderLinks = () => {
    return (
      <>
        <div className={cn('headerLinks', isWhite && 'headerLinksWhite')}>
          <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/');
            }}
            className={cn('headerLink', window.location.pathname === '/' && 'headerLinkActive')}
          >
            Home
          </span>
          <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/about');
            }}
            className={cn('headerLink', window.location.pathname === '/about' && 'headerLinkActive')}
          >
            About
          </span>
          <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/acquisitions');
            }}
            className={cn('headerLink', window.location.pathname === '/acquisitions' && 'headerLinkActive')}
          >
            Acquisitions
          </span>
          <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/solutions');
            }}
            className={cn('headerLink', window.location.pathname === '/solutions' && 'headerLinkActive')}
          >
            Staffing Solutions
          </span>
          <span
            onClick={() => {
              setIsMenuOpen(false);
              navigate('/platform');
            }}
            className={cn('headerLink', window.location.pathname === '/platform' && 'headerLinkActive')}
          >
            Platform
          </span>
        </div>
        <span className='headerContact' onClick={() => onFormClick('Looking to hire talent')}>
          Contact Us
        </span>
      </>
    );
  };

  return (
    <div className={cn('header')}>
      <div className='headerContent'>
        <div className='headerLogo'>
          <img src={Logo} alt='Logo' />
          <img src={isWhite && !isMenuOpen ? LogoTextWhite : LogoText} alt='Logo' />
        </div>
        {isMobile ? (
          <span className='headerMenu' onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? (
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path
                  d='M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z'
                  fill='#8C8B9A'
                />
              </svg>
            ) : (
              <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                <path d='M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z' fill={isWhite ? '#fff' : '#003733'} />
              </svg>
            )}
          </span>
        ) : (
          renderHeaderLinks()
        )}
        {isMenuOpen && <div className='phoneHeaderMenu'>{renderHeaderLinks()}</div>}
      </div>
    </div>
  );
};

export default Header;
